import React from 'react';

import websitePage from 'hoc/websitePage/websitePage';

import CreditCardNuControlConditions
from '../../../screens/CreditCardNuControlConditions/CreditCardNuControlConditions';
import { companyFooterTypes } from '../../../patterns/MultiProductFooter/patterns/company/FooterCompany';
import MultiProductFooter, { footerTypes } from '../../../patterns/MultiProductFooter/MultiProductFooter';
import HeaderCTA from '../../../components/HeaderCTA/HeaderCTA';

export default websitePage(CreditCardNuControlConditions, {
  routeKey: 'CREDIT_CARD_NU_CONTROL_CONDITIONS',
  footerType: footerTypes.FULL,
  companyFooterType: companyFooterTypes.ONLY_CREDITS,
  components: {
    footer: MultiProductFooter,
  },
  header: {
    nuLogoColor: 'primary',
    cta: (
      <HeaderCTA
        btnLabel="MULTI_PRODUCT_HOME.HERO.FORM.BUTTON_LABEL"
        href="/co"
      />
    ),
    layout: {
      showHeaderCTA: false,
      showHeaderMenu: true,
    },
  },
});
